"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param {any} object
 */
function instanceOfFormField(object) {
    return 'model' in object;
}
exports.instanceOfFormField = instanceOfFormField;
/**
 * @param {FormField} object
 */
function instanceOfValueFormField(object) {
    return 'indexField' in object;
}
exports.instanceOfValueFormField = instanceOfValueFormField;
/**
 * @param {FormField} object
 */
function instanceOfButtonFormField(object) {
    return 'buttonField' in object;
}
exports.instanceOfButtonFormField = instanceOfButtonFormField;
/**
 * @param {FormField} object
 */
function instanceOfFormFieldSection(object) {
    return 'fields' in object;
}
exports.instanceOfFormFieldSection = instanceOfFormFieldSection;
